<template>
    <div>
        <b-form @submit="onSubmit"> 
        <b-row>
            <b-col cols="12" xl="4" class="my-1"> 
              
                    <b-button @click="goToHome()" variant="transparent" size="sm" class="pull-left">
                        <font-awesome-icon icon="angle-left" size="2x" />
                    </b-button>
                    <h3 class="text-themecolor my-1">Document {{$route.params.documentId}}</h3>
                
            </b-col>
        </b-row>
        <b-row>
            <b-col md="7">
                <b-row>
                    <b-button size="sm"  variant="themecolor" class="mr-1">Onverwerkbaar & volgende</b-button>
                </b-row>
                <b-row>
                <h5><b>Melding</b></h5>
                <p>Dit is de melding tekst , Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ornare id est et facilisis. Aenean ac pellentesque eros. Maecenas finibus, massa sed blandit sagittis, ante massa facilisis purus, egestas mattis mi orci ac leo. Donec neque neque, rhoncus a mauris eu, gravida molestie ante. Vestibulum bibendum nunc tellus. In hac habitasse platea dictumst. Integer eget velit dignissim, consectetur tellus sit amet, aliquam lorem. Integer vel risus pulvinar dui sodales ultricies
                </p>
                </b-row>
                <b-row>
                    <h5><b>Trigger</b></h5>
                    <b-form-group label-cols label-for="triggerId">
                            <b-form-input id="triggerId" v-model="command.triggerId" type="text" />
                            <validation element="triggerId" />
                    </b-form-group>
                <hr>
                </b-row>
            <b-row>
                <b-col md="6" class="pl-0">
                    <b>Aangepast door klant</b>
                </b-col>
                <b-col md="6" class="pl-0">
                    {{document.IsEdited ? "Ja op " + (document.lastModified | datetime)  : "Nee"}}
                </b-col>
            </b-row>
            
            <b-row>
                <b-button size="sm" class="fixed-button" type="submit"  variant="themecolor">{{$t('buttons.opslaan')}}</b-button>
                <b-button size="sm"  variant="themecolor" v-on:click="goToTrigger">Regex</b-button>
            </b-row>
            </b-col>
            <b-col md="5" class="my-1">            
                    <v-zoomer>                      
                        <img :src="'data:image/jpeg;base64,'+ image" class="w-100 h-100" />
                    </v-zoomer>          
            </b-col>
        </b-row>
        </b-form>
    </div>
</template>
<script>
//Import store
import { mapGetters, mapActions } from 'vuex'
import Command from './command'


export default {
    name: 'document-detail',
    data() {
        return {
            command: new Command(),
            image: ''
        }
    },
    computed: {
        ...mapGetters('fmmodule',['document']),
    },
    methods: {
        ...mapActions('fmmodule',['find','update','getImage']),
        goToHome()
        {
            this.$router.push({ name: `documents:index`});      
        },
        onSubmit(event) {
            event.preventDefault();
            var vm = this;
            var payload = {
                resource: 'documenten',
                params: vm.command
            };
            vm.update(payload)
                .then(()=> {
                    vm.goTo('index');
                });
        },
        goTo(name) {
            var vm = this;
            vm.$router.push({ name: `documenten:${name}` });
        },
        goToTrigger(){
            var vm = this;
            this.$router.push({ name: `documents:trigger`, params: { documentId: vm.command.id, triggerId: vm.command.triggerId } });
        },
        LoadImage()
        {
            var vm = this;
            vm.getImage(
                {
                    resource:"images",
                    filename: vm.document.filename
                }
                ).then((response) => {
                    this.image = response;
                }  )
        }
    },
    created() {
        var vm = this;
        vm.find({
            resource: 'documenten',
            id: this.$route.params.documentId
        });
        vm.command = new Command(vm.document);
        this.LoadImage();
    }

}
</script>